import { PaymentMethod, PaymentMethodTypes } from '@/shared/types/payment-methods';

import { SelectPaymentMethodAction } from '@/shared/actions/select-payment-method';
import { UpdatePaymentFormValidationAction } from '@/shared/actions/update-payment-form-validation';

import { SELECT_PAYMENT_METHOD, UPDATE_PAYMENT_FORM_VALIDATION } from '@/shared/constants/action-types';


export enum PaymentFormValidationTypes {
    PAYER = 'payer',
    CARD  = 'card'
}

type State = {
    paymentMethods: PaymentMethod[]
    validations: Record<PaymentFormValidationTypes, boolean>
}

const initialState: State = {
    paymentMethods: [
        {
            type: PaymentMethodTypes.CARD,
            selected: true,
            disabled: false,
        },
        // {
        //     type: PaymentMethodTypes.QRCPAY,
        //     selected: false,
        //     disabled: false,
        // },
    ],
    validations: {
        payer: true,
        card: false,
    },
};


export const payment = (state = initialState, action: SelectPaymentMethodAction | UpdatePaymentFormValidationAction) => {
    switch (action.type) {
        case SELECT_PAYMENT_METHOD: {
            const { type } = (action as SelectPaymentMethodAction).payload;
            const paymentMethods = state.paymentMethods.map(paymentMethod => ({
                ...paymentMethod,
                selected: paymentMethod.type === type,
            }));

            return { ...state, paymentMethods };
        }
        case UPDATE_PAYMENT_FORM_VALIDATION: {
            const { type, valid } = (action as UpdatePaymentFormValidationAction).payload;
            const validations = {
                ...state.validations,
                [type]: valid,
            };

            return { ...state, validations };
        }
        default: return state;
    }
};
